<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
        h4 {{item.title}}
        p {{item.desc}}


  section.u-mt-md
    .grid.is-widescreen-8.is-desktop-10
      .column
        AppTitle.u-mb-xm(:title="$t('sec3')" tag="h2")
        p.u-text-lg.u-mb-xs {{$t('sec3Desc')}}
        AppLink(v-if="$t('sec3Url')" :to="$t('sec3Url')" :title="$t('learnMore')" class="button-link is-small") {{$t('learnMore')}}

  .u-mb-md

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Logo design",
    "pageDesc":"We help you create a custom professional logo that suits your identity whether pictorial, wordmark, letter form or emblems.",
    "mantra":"Design your |brand logo.",
    "mantraDesc":"Logos are a small part of the branding process, however, it is the main representative of the company. It shouldn’t necessarily have a meaning, but it must leave an impression.",
    "sec1":"Small, but mighty.",
    "sec1Items":{
      "1":{
        "title":"Wordmarks",
        "desc":"Using your company name or an acronym as the logo base. Customizing every letter and channing in font characteristics to come up with a unique wordmark."
      },
      "2":{
        "title":"Abstract marks",
        "desc":"Building your logo based on a single concept, idea or brand attribute. Then illustrating it with a little ambiguity to depending on visual forms."
      },
      "3":{
        "title":"Pictorial marks",
        "desc":"Using an easily recognizable image that could be related to the brand attributes and tweaking it a little with the brand style to create a more simplified version."
      },
      "4":{
        "title":"Emblems",
        "desc":"Mixing your organization name with a pictorial element and using it for packing, signage or even digital use."
      },
      "5":{
        "title":"Letterforms",
        "desc":"Using one or more of your brand letters to create a distinctive mark that carries your brand personality."
      }
    },

    "sec2Items":{
      "1":{
        "title":"Recognizable",
        "desc":"A logo should create an emotional bond with the viewers so they can memorize it through the impression booked in their minds."
      },
      "2":{
        "title":"Functional",
        "desc":"From prints to digital use, we develop logos that scale with your needs and fits with your essential placements."
      },
      "3":{
        "title":"Industry based",
        "desc":"Not all logos work for all industries. Food reality is different is different corporations and we consider that during the development process."
      }
    },
    "sec3":"Logo development is just |a small step.",
    "sec3Desc":"Develop a full brand identity starting with your current logo, moving to stationary and other brand implementation.",
    "sec3Url":"/services/brand-identity-design"
  },
  "ar": {
    "pageTitle":"تصميم الشعارات",
    "pageDesc":"نساعدك في إنشاء شعار يناسب هويتك وطبيعة عملك  التجارى سواء كانت على هيئة صورة أو علامة تجارية أو حروف أو شعار.",
    "mantra":"صمم الشعارات التي |تتناسب مع روح هويتك.",
    "mantraDesc":"الشعار هو جزء صغير في عملية بناء العلامة التجارية، وعلى الرغم من ذلك فهو يعتبر الممثل الرئيسي للشركة. ليس من الضروري أن يكون له معنى ولكن الأهم أن يترك انبطاعًا حول الهوية. ",
    "sec1":"التفاصيل الصغيرة تخلق تأثيرات كبيرة.",
    "sec1Items":{
      "1":{
        "title":"كلمة تجارية",
        "desc":"تستطيع استخدام اسم شركتك أو حتى اختصارها كقاعدة لتصميم الشعار. خصص كل حرف من الحروف ليمنحك الانطباع الذي تريد أن يحصل عليه جمهورك من الوهلة الأولي."
      },
      "2":{
        "title":"علامة مجردة",
        "desc":"صمم شعارك على أساس مفهوم ما أو فكرة أو سمة للعلامة التجارية، وقم بتوضيح ذلك من خلال بعض الغموض باستخدام الأِشكال البصرية."
      },
      "3":{
        "title":"علامات تصويرية",
        "desc":"استخدم صور سهل التعرف عليها وفهمها من خلال ارتباطها الوثيق بالهوية وقم بتغييرها قليلًا مع نمط الهوية التجارية من أجل إنشاء نسخة أكثر بساطة."
      },
      "4":{
        "title":"الرموز",
        "desc":"امزج بين اسم مؤسستك وبين العناصر التصويرية واستخدامها من أجل  التغليف أو اللافتات أو حتى الاستخدامات الرقمية."
      },
      "5":{
        "title":"Letterforms",
        "desc":"استخدام واحد أو أكثر من حروف علامتك التجارية لإنشاء علامة مميزة تحمل شخصية علامتك التجارية."
      }
    },

    "sec2Items":{
      "1":{
        "title":"التعرف على الشعار",
        "desc":"يجب أن يخلق الشعار رابطًا عاطفيًا مع العملاء حتى لا ينسوه مطلقًا من خلال الانطباع الذي تم حجزه في أذهانهم."
      },
      "2":{
        "title":"استخدامات الشعار",
        "desc":"من المطبوعات إلى الاستخدام الرقمي، نقوم بتصميم الشعار الذي يتناسب مع احتياجاتك ومع المواضع الأساسية الخاصة بك."
      },
      "3":{
        "title":"تصميم الشعار تبعًا لعملك",
        "desc":"ليس كل شعار مناسب لجميع الصناعات. شعارات الأغذية مختلفة عن  الشركات الاخري ونحن نهتم بذلك أثناء عملية التصميم"
      }
    },
    "sec3":"تطوير الشعار هو مجرد خطوة صغيرة.",
    "sec3Desc":"طوّر هوية علامة تجارية كاملة بدءًا من شعارك الحالي، وانتقل إلى الأدوات المكتبية وغيرها.",
    "sec3Url":"/services/brand-identity-design"
  }
}
</i18n>
